module.exports = __webpack_public_path__ + "img/partner2.44d32d55.jpg";